const SaveIcon = ({ color = "white" }: { color?: string }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.3125 3.59375L15.2813 0.8125L15.2188 0.78125C15 0.625 14.75 0.53125 14.5313 0.53125H3.71875C2.40625 0.53125 1.34375 1.59375 1.34375 2.90625V17.0312C1.34375 18.3438 2.40625 19.4062 3.71875 19.4062H16.2813C17.5938 19.4062 18.6563 18.3438 18.6563 17.0312V4.40625C18.6563 4.125 18.5625 3.84375 18.3125 3.59375ZM12.4688 1.96875V3.75H5.9375V1.96875H12.4688ZM6.71875 18.0625V12.2812H13.2813V18.0312H6.71875V18.0625ZM17.25 17.0625C17.25 17.5938 16.8125 18.0312 16.2813 18.0312H14.6875V12C14.6875 11.4062 14.1875 10.9062 13.5938 10.9062H6.40625C5.8125 10.9062 5.3125 11.4062 5.3125 12V18.0625H3.71875C3.1875 18.0625 2.75 17.625 2.75 17.0938V2.9375C2.75 2.40625 3.1875 1.96875 3.71875 1.96875H4.53125V4.0625C4.53125 4.65625 5.03125 5.15625 5.625 5.15625H12.7813C13.375 5.15625 13.875 4.65625 13.875 4.0625V1.96875H14.4375L17.25 4.5625V17.0625Z"
        fill={color}
      />
      <path
        d="M11.2812 13.2812H8.71875C8.34375 13.2812 8 13.5937 8 14C8 14.4063 8.3125 14.7187 8.71875 14.7187H11.2812C11.6562 14.7187 12 14.4063 12 14C12 13.5937 11.6562 13.2812 11.2812 13.2812Z"
        fill={color}
      />
      <path
        d="M11.2812 15.6562H8.71875C8.34375 15.6562 8 15.9688 8 16.375C8 16.7813 8.3125 17.0938 8.71875 17.0938H11.2812C11.6562 17.0938 12 16.7813 12 16.375C12 15.9688 11.6562 15.6562 11.2812 15.6562Z"
        fill={color}
      />
    </svg>
  );
};

export default SaveIcon;
